import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { functionalities, privileges } from '@/shared/services/AuthService';
import { hasAssignments } from '@/shared/components/security/HasAssignments';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import messages from './relationOverviewMessages';

const GlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onUpdateTaskSchedule,
    onUpdateField,
    onCreateRegistration,
    onSetInvoiceSchedule,
    onCreateTask,
    onSendMail,
    onUpdateTeam,
    onUpdateTags,
    onAddAssignment,
    onUpdateRelationUser,
    onGenerateDocuments,
    onSearchOnPeppolNetwork,
  } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.RelationGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="small"
        bsStyle="default"
        className="btn-inverse margin10L"
        id="global-actions-button"
        disabled={disabled}
        title={intl.formatMessage(messages.GlobalActions)}
        pullRight
      >
        <MenuItemWithSecurity
          functionality={functionalities.TaskSchedules}
          privilege={privileges.Create | privileges.Delete}
          onSelect={onUpdateTaskSchedule}
          id="global-actions-button-AddOrRemoveTaskSchedule"
        >
          {intl.formatMessage(messages.AddOrRemoveTaskSchedule)}
        </MenuItemWithSecurity>

        <MenuItemWithSecurity
          functionality={functionalities.PlannedTask}
          privilege={privileges.Create}
          onSelect={onCreateTask}
          id="global-actions-button-CreatePlannedTask"
        >
          {intl.formatMessage(messages.CreateTaskWithoutPlanning)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          onSelect={onUpdateField}
          id="global-actions-button-UpdateField"
        >
          {intl.formatMessage(messages.UpdateField)}
        </MenuItemWithSecurity>

        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          onSelect={onUpdateRelationUser}
          id="global-actions-button-UpdateRelationUser"
        >
          {intl.formatMessage(messages.UpdateRelationUser)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          functionality={functionalities.RegistrationOwn}
          privilege={privileges.Create}
          onSelect={onCreateRegistration}
          id="global-actions-button-NewRegistration"
        >
          {intl.formatMessage(messages.NewRegistration)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
          onSelect={onSetInvoiceSchedule}
          id="global-actions-button-SetInvoiceSchedule"
        >
          {intl.formatMessage(messages.SetInvoiceSchedule)}
        </MenuItemWithSecurity>
        {hasAssignments() && (
          <MenuItemWithSecurity
            functionality={functionalities.InvoiceDraft}
            privilege={privileges.Update}
            onSelect={onAddAssignment}
            id="global-actions-button-AddAssignment"
          >
            {intl.formatMessage(messages.AddAssignment)}
          </MenuItemWithSecurity>
        )}

        <MenuItemWithSecurity
          functionality={functionalities.InteractionsOwn}
          privilege={privileges.Create}
          onSelect={onSendMail}
          id="global-actions-button-SendEmail"
        >
          {intl.formatMessage(messages.SendEmail)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          onSelect={onUpdateTeam}
          id="global-actions-button-AddOrRemoveTeams"
        >
          {intl.formatMessage(messages.AddOrRemoveTeams)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          onSelect={onUpdateTags}
          id="global-actions-button-AddOrRemoveTags"
        >
          {intl.formatMessage(messages.AddOrRemoveTags)}
        </MenuItemWithSecurity>

        <MenuItemWithSecurity
          functionality={functionalities.Documents}
          privilege={privileges.Create}
          onSelect={onGenerateDocuments}
          id="global-actions-button-GenerateDocuments"
        >
          {intl.formatMessage(messages.GenerateDocuments)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          onSelect={onSearchOnPeppolNetwork}
          id="global-actions-button-SearchOnPeppolNetwork"
        >
          {intl.formatMessage(messages.SearchOnPeppolNetwork)}
        </MenuItemWithSecurity>
      </DropdownButton>
    </span>
  );
};

GlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onUpdateTaskSchedule: PropTypes.func.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  onCreateRegistration: PropTypes.func.isRequired,
  onSetInvoiceSchedule: PropTypes.func.isRequired,
  onCreateTask: PropTypes.func.isRequired,
  onSendMail: PropTypes.func.isRequired,
  onUpdateTeam: PropTypes.func.isRequired,
  onUpdateTags: PropTypes.func.isRequired,
  onAddAssignment: PropTypes.func.isRequired,
  onUpdateRelationUser: PropTypes.func.isRequired,
  onGenerateDocuments: PropTypes.func.isRequired,
  onSearchOnPeppolNetwork: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
GlobalActionsButton.defaultProps = { disabled: false };
export default injectIntl(GlobalActionsButton);
